import { render, staticRenderFns } from "./wzgn.vue?vue&type=template&id=98616af2&scoped=true"
import script from "./wzgn.vue?vue&type=script&lang=js"
export * from "./wzgn.vue?vue&type=script&lang=js"
import style0 from "./wzgn.vue?vue&type=style&index=0&id=98616af2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98616af2",
  null
  
)

export default component.exports